import { useRef } from 'react';

export const useScrollbarWidth = (): number => {
  const didCompute = useRef(false);
  const widthRef = useRef(0);

  if (didCompute.current) return widthRef.current;

  // ЭТАП 1 · Шаг 3 — SSR-guard: ширина скроллбара измеряется реальным DOM-узлом
  // (createElement + offsetWidth). На сервере document нет — возвращаем 0 без
  // мемоизации (не выставляем didCompute), чтобы на клиенте после гидрации
  // измерение произошло по-настоящему при первом рендере в браузере.
  if (typeof document === 'undefined') {
    return 0;
  }

  // Creating invisible container
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  document.body.appendChild(outer);

  // Creating inner element and placing it in the container
  const inner = document.createElement('div');
  outer.appendChild(inner);

  // Calculating difference between container's full width and the child width
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;

  // Removing temporary elements from the DOM
  outer?.parentNode?.removeChild(outer);

  didCompute.current = true;
  widthRef.current = scrollbarWidth;

  return scrollbarWidth;
};
